import React from "react";

import { UserFullNameReferenceField } from "../../../components/fields/UserFullNameReferenceField";
import { systemName } from "../../../utils/constants";

export const ConfirmedByField = ({ record, ...rest }) => {
	if (record?.is_confirmed && !record.confirmed_by) {
		return <span>{systemName}</span>;
	}
	return <UserFullNameReferenceField record={record} {...rest} />;
};
